import { ItemStyle } from './TinyVirtualList';

interface IndexRatio {
  end: number;
  start: number;
}

// Used when mixing diferent arrays in the same VirtualList
// will get the length of every array and return the start and end position
export const getIndexesRatio = (...dataLength: number[]): IndexRatio[] => {
  return dataLength.reduce((acc: IndexRatio[], cur, index) => {
    if (index === 0) {
      return [...acc, { end: cur, start: 0 }];
    }

    const prev = acc[index - 1];

    return [
      ...acc,
      {
        end: prev.end + cur,
        start: prev.end,
      },
    ];
  }, []);
};

// Used to calculate the length of the arrays when the VirtualList should display a title
// The title should be in the first List if the list has items
// otherwise it should go on the second list
export const getLengthWithExtra = <T, U, V>(
  extra: number,
  arr1: T[],
  arr2?: U[],
  arr3?: V[],
): [number, number, number] => {
  const ret1 = arr1.length > 0 ? arr1.length + extra : 0;
  const arr2Length = arr2 ? arr2.length : 0;
  const arr3Length = arr3 ? arr3.length : 0;
  const ret2 = ret1 === 0 && arr2Length > 0 ? arr2Length + extra : arr2Length;
  const ret3 = ret1 === 0 && ret2 === 0 && arr3Length > 0 ? arr3Length + extra : arr3Length;

  return [ret1, ret2, ret3];
};

interface Styles {
  [key: string]: string | number;
}

// parsing the style coming from the VirtualList component
// needed to match the HTML CSS properties type
export const getItemStyle = (style: ItemStyle): Styles => ({
  ...(style.height ? { height: style.height } : {}),
  ...(style.width ? { width: style.width } : {}),
  ...(style.position ? { position: style.position } : {}),
  ...(style.top ? { top: style.top } : {}),
});
